"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getErrorOrUnknown = exports.createUnknownError = exports.getFirstError = exports.getErrors = exports.isAxiosError = void 0;
// eslint-disable-next-line import/no-extraneous-dependencies
const axios_1 = __importDefault(require("axios"));
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const isAxiosError = (error) => {
    return axios_1.default.isAxiosError(error);
};
exports.isAxiosError = isAxiosError;
const getErrors = (error) => {
    var _a;
    try {
        return (_a = error.response) === null || _a === void 0 ? void 0 : _a.data.errors;
    }
    catch (e) {
        console.error('Cant get errors from error response');
        console.debug(e);
        console.debug(error.config);
        return undefined;
    }
};
exports.getErrors = getErrors;
const getFirstError = (error) => {
    const errors = (0, exports.getErrors)(error);
    return errors ? errors[0] : undefined;
};
exports.getFirstError = getFirstError;
const createUnknownError = (title) => ({
    code: betweb_openapi_axios_1.ErrorCode.Unknown,
    title,
    message: '',
    reasons: [],
});
exports.createUnknownError = createUnknownError;
const getErrorOrUnknown = (error) => {
    try {
        let backendError;
        if ((0, exports.isAxiosError)(error)) {
            backendError = (0, exports.getFirstError)(error);
        }
        return backendError || (0, exports.createUnknownError)(error.message);
    }
    catch (e) {
        return (0, exports.createUnknownError)(error.message);
    }
};
exports.getErrorOrUnknown = getErrorOrUnknown;
//# sourceMappingURL=index.js.map